module.exports = __webpack_public_path__ + "img/kkb_cee32.31a143f6.jpg";